import { useMutation } from '@apollo/client';
import { READ_BENEFITS } from '@queries/readBenefits.tsx';
import AccountContext from 'context/AccountContext';
import { CHALLENGE_CUSTOMER } from 'graphql/mutations/challengeCustomer';
import { GET_UNIFIED_PERMITS } from 'graphql/queries/getUnifiedPermits';
import { useContext } from 'react';
import { usePermitStore } from 'stores/permitStore';
import {
  Mutation,
  MutationChallengeCustomerArgs,
} from 'types/generatedSchemaTypes';

const useVerifyCustomerWithHsaId = () => {
  const { setCustomerVerificationStatus } = usePermitStore();
  const { refetchPermits } = useContext(AccountContext);
  const [verifyCustomer, { data, error }] = useMutation<
    Mutation,
    MutationChallengeCustomerArgs
  >(CHALLENGE_CUSTOMER, {
    refetchQueries: [
      {
        query: READ_BENEFITS,
      },
      {
        query: GET_UNIFIED_PERMITS,
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: async (data) => {
      if (data.challengeCustomer?.status === 'FAILED') {
        setCustomerVerificationStatus('failed');
      }
      if (data.challengeCustomer?.status === 'PENDING') {
        setCustomerVerificationStatus('pending');
      }
      if (data.challengeCustomer?.status === 'SUCCESS') {
        // Permit creation is async (membership → SQS); delayed refetch covers lag.
        setTimeout(() => {
          void refetchPermits?.();
        }, 3000);
        setCustomerVerificationStatus('success');
      }
    },
    onError: () => {
      setCustomerVerificationStatus('failed');
    },
  });
  return {
    verifyCustomer,
    error: Boolean(
      error ||
        data?.challengeCustomer?.status === 'FAILED' ||
        data?.challengeCustomer?.status === 'PENDING'
    ),
  };
};
export default useVerifyCustomerWithHsaId;
